import { Component } from '@angular/core';

@Component({
    selector: 'app-mp-welcome',
    imports: [],
    templateUrl: './mp-welcome.component.html',
    styleUrl: './mp-welcome.component.scss'
})
export class MpWelcomeComponent {}